import {ActionIcon, Group, Popover} from "@mantine/core";
import {IconCoins} from "@tabler/icons-react";
import {BaseSelect} from "../../../../select/base-select";
import {MouseEventHandler} from "react";

export type CostHeaderProps = {
  defaultTitle: string
  rateModels: string[]
  selectedRateModel?: string
  rateModelSelectOpened: boolean
  setRateModelSelectOpened: (opened: boolean) => void
  onRateModelSelectOpened: MouseEventHandler
  onRateModelChange: (value: string | null) => void
}

export const CostHeader = (props: CostHeaderProps) => {
  const {
    defaultTitle,
    rateModels,
    selectedRateModel,
    rateModelSelectOpened,
    setRateModelSelectOpened,
    onRateModelSelectOpened,
    onRateModelChange
  } = props

  return (
    <Group spacing="xs" position="left">
      <Popover
        opened={rateModelSelectOpened}
        onChange={setRateModelSelectOpened}
        width={300}
        trapFocus={true}
        position="top"
        withArrow={true}
        shadow="md">
        <Popover.Target>
          <ActionIcon variant="transparent" onClick={onRateModelSelectOpened}>
            <IconCoins size={14}/>
          </ActionIcon>
        </Popover.Target>
        <Popover.Dropdown
          sx={(theme) => ({background: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white})}>
          <BaseSelect
            defaultValue={selectedRateModel}
            placeholder={"Rate Model"}
            data={rateModels}
            allowDeselect={true}
            onClick={e => e.preventDefault()}
            onChange={onRateModelChange}/>
        </Popover.Dropdown>
      </Popover>
      {(selectedRateModel ? (selectedRateModel + " ") : "") + defaultTitle}
    </Group>
  )
}
